module.exports = __webpack_public_path__ + "media/images/icons/filled/html5-3262da0ec5791c86017d8c774d9a8303.svg";